import { ABILITIES, EMOTES } from '@kokun/shared';
import { ACTION_LABELS, keyLabel, settings, type Action } from '../../app/settings';
import { h, modal } from '../dom';

export function openHowToPlay() {
  const b = settings.get().bindings;
  const k = (a: Action) => h('kbd', null, keyLabel(b[a]));
  modal(
    'Cómo jugar',
    [
      h('p', { class: 'lead' }, 'Entra con tus amigos, completad la misión… y no confíes demasiado en nadie.'),
      h('h3', null, '🎯 Objetivo'),
      h(
        'ol',
        null,
        h('li', null, 'Encontrad las 3 células de energía repartidas por Kokun City y metedlas en el generador.'),
        h('li', null, 'Pisad a la vez las dos placas de la plaza (o empuja una caja encima de una).'),
        h('li', null, 'Mirad la pantalla del parque y girad las válvulas del generador hasta que coincidan los colores.'),
        h('li', null, 'Tirad de la palanca y quedaos dentro del anillo hasta que se cargue.'),
        h('li', null, 'Después, ¡lluvia de monedas! Gana quien más recoja.'),
      ),
      h('h3', null, '⌨️ Controles'),
      h(
        'div',
        { class: 'controls-grid' },
        h('span', null, k('forward'), k('left'), k('back'), k('right')),
        h('span', null, 'Moverse'),
        h('span', null, h('kbd', null, 'Ratón')),
        h('span', null, 'Girar la cámara (haz clic en el juego) · rueda: zoom'),
        ...(['jump', 'sprint', 'interact', 'prank', 'special', 'scoreboard', 'chat'] as Action[]).flatMap((a) => [h('span', null, k(a)), h('span', null, ACTION_LABELS[a])]),
        h('span', null, h('kbd', null, '1'), '–', h('kbd', null, '6')),
        h('span', null, `Emotes: ${EMOTES.map((e) => e.icon).join(' ')}`),
        h('span', null, h('kbd', null, 'Esc')),
        h('span', null, 'Pausa y ajustes'),
      ),
      h('p', { class: 'muted small' }, 'En móvil: joystick a la izquierda, arrastra a la derecha para mirar y usa los botones.'),
      h('h3', null, '🤡 Bromas'),
      h(
        'ul',
        null,
        ...Object.values(ABILITIES).map((a) => h('li', null, `${a.icon} `, h('b', null, a.name), ` — ${a.description} (recarga ${a.cooldown} s)`)),
        h('li', null, '🔴 ', h('b', null, 'Botón rojo'), ' — activa un evento aleatorio para todo el mundo.'),
        h('li', null, '🌀 ', h('b', null, 'Teletransportadores'), ' — te llevan a un sitio seguro… al azar.'),
        h('li', null, '🫥 ', h('b', null, 'Interruptor del puente'), ' — hace desaparecer el puente de la zona de entrenamiento.'),
      ),
      h('p', { class: 'muted small' }, 'Reglas anti-abuso: tras recibir una broma eres inmune 3 s, y nadie puede bromear con la misma persona más de 3 veces por minuto. Todo efecto es temporal.'),
    ],
    [{ label: '¡Entendido!', cls: 'btn primary', run: () => undefined }],
    { wide: true },
  );
}
